/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One in-app notification row for the bell feed
 */
export type NotificationView = {
    id?: string;
    type?: NotificationView.type;
    actorName?: string;
    actorInitials?: string;
    /**
     * Structured payload for client-side i18n rendering
     */
    data?: Record<string, any>;
    isRead?: boolean;
    createdAt?: string;
};
export namespace NotificationView {
    export enum type {
        TASK_ASSIGNED = 'task_assigned',
        TASK_CHANGED = 'task_changed',
    }
}

